export {
  RelatedStoryCard,
  type RelatedStoryCardProps,
} from "./RelatedStoryCard";

export { apiToRelatedStoryCardProps } from "./apiToRelatedStoryCardProps";
